import { Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbItem } from '@scalefast/core';
import { BreadcrumbService } from '@scalefast/ecommerce-core';
import { Observable } from 'rxjs';
import { ContentfulSectionContent } from 'src/app/core/interfaces/Contentful/ContentfulSectionContent';

@Component({
  selector: 'app-contentful-article-breadcrumbs',
  templateUrl: './contentful-article-breadcrumbs.component.html',
  styleUrls: ['./contentful-article-breadcrumbs.component.scss'],
  standalone: true,
  imports: [RouterLink],
})
export class AppContentfulArticleBreadcrumbComponent implements OnInit {
  @Input() contentfulSectionContent: ContentfulSectionContent | undefined;

  articleBreadcrumbs: BreadcrumbItem | undefined;
  breadcrumbs$: Observable<BreadcrumbItem[]>;

  constructor(private readonly breadcrumbService: BreadcrumbService) {
    this.breadcrumbs$ = this.breadcrumbService.breadcrumbs$;
  }

  ngOnInit() {
    if (this.contentfulSectionContent?.contentType === 'articleOverview') {
      this.breadcrumbs$.subscribe((breadcrumbs) => {
        const breadcrumbsLength = breadcrumbs.length;

        if (breadcrumbs.length > 3) {
          this.articleBreadcrumbs = {
            label: breadcrumbs[breadcrumbsLength - 3].label + ' - ' + breadcrumbs[breadcrumbsLength - 2].label,
            path: breadcrumbs[breadcrumbsLength - 2].path,
          };
        }
      });
    }
  }
}
